import React, { useState, useEffect } from 'react';
import './NewsFlashAdmin.css';

const NewsFlashAdmin = ({ currentNewsText, onUpdateNews, onClose }) => {
  const [isLoginView, setIsLoginView] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [newNewsText, setNewNewsText] = useState('');
  const [error, setError] = useState('');
  const [credentials, setCredentials] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    
    // Just store credentials and move to next screen
    // Server will validate when we try to update
    setCredentials({ email, password });
    setIsLoginView(false);
    setError('');
  };

  const handleUpdateNews = async () => {
    if (newNewsText.trim() && credentials) {
      setIsLoading(true);
      try {
        await onUpdateNews(newNewsText, credentials);
        // Parent will handle closing on success
      } catch (error) {
        setError('Invalid credentials or update failed');
        setIsLoginView(true); // Go back to login
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleCancel = () => {
    setEmail('');
    setPassword('');
    setNewNewsText('');
    setError('');
    setCredentials(null);
    setIsLoginView(true);
    onClose();
  };

  // Close on escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        handleCancel();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, []);

  return (
    <div className="news-admin-overlay" onClick={handleCancel}>
      <div className="news-admin-modal" onClick={(e) => e.stopPropagation()}>
        {isLoginView ? (
          <>
            <h2 className="admin-modal-title">Admin Login</h2>
            <form onSubmit={handleLogin} className="admin-login-form">
              <div className="form-group">
                <label htmlFor="admin-email">Email</label>
                <input
                  id="admin-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter admin email"
                  required
                  autoFocus
                />
              </div>
              <div className="form-group">
                <label htmlFor="admin-password">Password</label>
                <input
                  id="admin-password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter admin password"
                  required
                />
              </div>
              {error && <div className="error-message">{error}</div>}
              <div className="modal-buttons">
                <button type="submit" className="btn-confirm">Login</button>
                <button type="button" className="btn-cancel" onClick={handleCancel}>Cancel</button>
              </div>
            </form>
          </>
        ) : (
          <>
            <h2 className="admin-modal-title">Update News Flash</h2>
            <div className="news-update-form">
              <div className="form-group">
                <label>Current News Flash</label>
                <div className="current-news-text">{currentNewsText || 'No current news flash'}</div>
              </div>
              <div className="form-group">
                <label htmlFor="new-news">New News Flash</label>
                <textarea
                  id="new-news"
                  value={newNewsText}
                  onChange={(e) => setNewNewsText(e.target.value)}
                  placeholder="Enter new news flash text..."
                  rows="3"
                  autoFocus
                />
              </div>
              <div className="modal-buttons">
                <button 
                  type="button" 
                  className="btn-confirm" 
                  onClick={handleUpdateNews}
                  disabled={!newNewsText.trim() || isLoading}
                >
                  {isLoading && <span className="loading-spinner"></span>}
                  {isLoading ? 'Updating...' : 'Confirm'}
                </button>
                <button 
                  type="button" 
                  className="btn-cancel" 
                  onClick={handleCancel}
                  disabled={isLoading}
                >
                  Cancel
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default NewsFlashAdmin;